import styled from "styled-components";
import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const WidgetControlStyled = styled.div`
    max-width: 600px;
    margin: 10px auto;
    position: relative;
    border: 2px solid transparent;
    :hover{
      border-color: #4f504f;    
    }
    &.selected{
      border-color: #4f504f;    
    }
    .actions{
        text-align: right;
        display: flex;
        justify-content: flex-end;
        opacity: 0;
        position: absolute;
        width: 100%;
        background: #000000c2;
        color: #fff;
        z-index: 1;
    }
    i{
        margin: 8px 4px;
    border-left: 2px solid #9e9e9e;
    padding-left: 11px;
    padding-right: 7px;
    line-height: 30px;
    cursor: pointer;
    svg{
        margin: 6px 4px;
    }
    :last-child{
        border-right: none;
    }
    :first-child{
        border-left: none;
    }
    }
    
    &.selected,
    :hover{
        .actions{
            opacity: 1;
        }
    }
`;


const WidgetControl = (props: any) => {
    return (
        <WidgetControlStyled className={props.selected ? 'selected' : ''}>
            <div className="actions">
                <i onClick={props.onEdit}> <FontAwesomeIcon icon="pencil-alt"/> </i>
                <i onClick={props.onAdd}> <FontAwesomeIcon icon="plus-square"/> </i>
                <i onClick={props.onDelete}> <FontAwesomeIcon icon="trash-alt"/> </i>
            </div>
            <div className="template">
                {props.children}
            </div>
        </WidgetControlStyled>
    );
};

export default WidgetControl;

